import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

import { Ref, ref, onMounted } from 'vue';

/********************************
 ************ VUETIFY ***********
 *******************************/
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import GaugeComponent from '@/components/SmartLink/dashboard/GaugeComponent.vue';
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import SingleCard from '@/components/SmartLink/topology/SingleCard.vue';
import SingleChart from '@/components/SmartLink/charts/SingleChart.vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS,STATUS } from '@/constants/labels';
import { COLOR } from '@/constants/colors';
import CONSTAPIS from '@/constants/apis';

/********************************
 ********** INTERFACES **********
 *******************************/
import { getCambiumDataByIp, getOperabilityByIp } from '@/services/Smartlink/Graphs';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'primaryGraphs',
  props: {
    ip          : { required:true, type:String },
    typesel     : { required:true, type:String },
    name        : { required:true, type:String },
    status      : { type:String}
},
  setup(__props) {

const props = __props;

const { xs, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ********** COMPONENTS **********
 *******************************/
const store = useStore();



        

const params = { 
    ip      : props.ip,
    type    : CONSTAPIS.APIS_STRINGS.latency,

};

/**
 * Variable para mostrar la gráfica del IEO y SINGLECARD, se oculta por completo si no hay DATOS desde la API
 */
const showTUM               = ref(false);
const finalItemOperability  = ref();

/**
 * Consulta a la API: "getAllOperabilityByIP"
 * Envia como parámetro la IP
 */
async function getOperability() {
    
    const allData = await getOperabilityByIp(params)
    
    if( allData.status === 400 ){
        showTUM.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showTUM.value = allData.showGraphs
        finalItemOperability.value = allData.data
    }

}


const arrayValues:Ref<number[][]>   = ref([]);

/**
 * Variable para mostrar los gráficos, se oculta por completo si no hay DATOS desde la API
 */
const showPrimaryGraph              = ref(true);

/**
 * Consulta a la API: "getGraphTopologyData"
 * envía como parámetro la ip y el tipo de pedido
 * (latency, cambium_data, linkradiohoriz)
 */
async function getDataGraph() {

    const allData = await getCambiumDataByIp(params)

    if( allData.status === 400 ){
        showPrimaryGraph.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showPrimaryGraph.value = allData.showGraphs
        arrayValues.value = allData.data
    }

}

/**
 * Regresa el color, de acuerdo al estado del equipo
 * @param estado 
 */
const getColorStatus = (estado:string) => {
    let finalColorStatus = COLOR.greyfake;

    if(estado.toUpperCase() === STATUS.ok)      finalColorStatus = COLOR.green;
    if(estado.toUpperCase() === STATUS.alert)   finalColorStatus = COLOR.yellow;
    if(estado.toUpperCase() === STATUS.alarm)   finalColorStatus = COLOR.red;
    if(estado.toUpperCase() === STATUS.down)    finalColorStatus = COLOR.greyfake;

    return finalColorStatus
}

onMounted( async() => {
    getOperability();
    getDataGraph();
})



return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (showPrimaryGraph.value)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        "min-width": "500",
        class: _normalizeClass([_unref(xs)?'card-dialogs-graph-wop':'card-dialogs-graph', "defaultCard"]),
        color: "bgtopology"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: "mx-1",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pa-0 py-4",
                style: {"max-width":"max-content"}
              }, {
                default: _withCtx(() => [
                  (showTUM.value)
                    ? (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 0,
                        class: "text-center",
                        color: "transparent",
                        width: "420",
                        style: {"min-width":"420"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(SingleCard, {
                            colorIcon: getColorStatus(__props.status??'superdown'),
                            middleText: __props.name,
                            bottomText: __props.ip,
                            isTopology: true,
                            typeItem: __props.typesel
                          }, null, 8, ["colorIcon", "middleText", "bottomText", "typeItem"]),
                          (finalItemOperability.value.length > 0)
                            ? (_openBlock(), _createBlock(GaugeComponent, {
                                key: 0,
                                recharge: false,
                                "array-items": finalItemOperability.value
                              }, null, 8, ["array-items"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_sheet, {
                color: "transparent",
                class: "ml-2",
                style: _normalizeStyle([_unref(smAndDown) ? 'width: 100%' : 'width: calc(100% - 428px);', {"align-content":"center"}])
              }, {
                default: _withCtx(() => [
                  (arrayValues.value.length !== 0)
                    ? (_openBlock(), _createBlock(SingleChart, {
                        key: 0,
                        name: 'Latency',
                        "first-array": arrayValues.value,
                        title:  _unref(t)('labels.latency'),
                        color: "#F6E5E5"
                      }, null, 8, ["first-array", "title"]))
                    : (_openBlock(), _createBlock(_component_v_sheet, {
                        key: 1,
                        class: "text-center",
                        color: "transparent"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(Prog_circular)
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})